import { LitElement, html, svg } from 'lit';

export class IconStairs32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Trappetrinn med diagonal pil opp</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M31 17.001 17.036 31M23 17.001h8v7.924M1 31v-8h8v-8h8V7h8V1.046"></path></svg>`; }
}
if (!customElements.get('f-icon-stairs32', IconStairs32)) {
  customElements.define('f-icon-stairs32', IconStairs32);
}